import React, { Component } from 'react';
import styled from "@emotion/styled";
import colors from "styles/colors";
import dimensions from "styles/dimensions";

const ButtonContainer = styled("button")`
    padding: 0;
    margin: 0;
    background-color: rgba(0,0,0,0);
    position: relative;
    display: inline-block;
    padding: 0 6vw;
    font-size: calc(0.75rem + 0.25vw - 0.8px);
    font-weight: 700;
    line-height: calc(2.5rem + 2vw - 6.4px);
    white-space: nowrap;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    vertical-align: middle;
    cursor: pointer;
    outline: 0;
    user-select: 0;
    border: 2px solid #303030;
    border-left-width: 12px;
    transition: color .15s ease-out;

    @media(min-width: ${dimensions.minwidthTablet}px) {
        letter-spacing: 2px;
        padding: 0 44px;
    }

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: -1;
      bottom: -1px;
      right: 10px;
      content: " ";
      background: #303030;
      transform: scaleX(0);
      transform-origin: 0 center;
      transition: transform .15s ease-out;
    }

    &:hover, &:focus {
      color: #fff;
    }

    &:hover:before, &:focus:before {
      transform: scaleX(1);
    }

    span.btnArrow {
      position: relative;
      display: inline-block;
      color: inherit;
      vertical-align: middle;
      width: 34px;
      margin-right: 2px;
      margin-left: 8px;
      transition: transform 2s;

      @media(min-width: ${dimensions.minwidthTablet}px) {
        margin-left: 24px;
      }

      ::before {
        border-top-width: 2px;
        content: "";
        display: block;
        width: 100%;
        border-top: .15em solid;
        border-color: inherit
      }
      ::after {
        border-width: 4px;
        content: "";
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 100%;
        height: 0;
        width: 0;
        border: .3em solid rgba(0,0,0,0);
        border-left-color: inherit;
        pointer-events: none;
      }
    }
`

class Button extends Component {
    render() {
        const { children, ...props } = this.props;
        return (
            <ButtonContainer
                onClick={this.props.onClick}
                {...props}>
                {this.props.children}
                <span class="btnArrow"></span>
            </ButtonContainer>
        );
    }
}

export default Button;